import React from 'react';
import { Avatar, Box, Button, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { alpha } from '@mui/material/styles';
import { LOGIN_ACCENT } from '../../auth/loginDarkTheme';
import { THEME_COLORS } from '../../../shared/constants/theme';

export default function MobileLockScreenOverlay({ open, user, onUnlock }) {
  if (!open) return null;

  const displayName = user?.fullName || user?.username || 'User';
  const initial = displayName[0]?.toUpperCase() || 'U';

  return (
    <Box
      role="dialog"
      aria-modal="true"
      aria-label="Screen locked"
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 2000,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2.5,
        background: `linear-gradient(165deg, ${alpha(THEME_COLORS.BACKGROUND_DARK, 0.98)} 0%, ${alpha('#020617', 0.98)} 100%)`,
        backdropFilter: 'blur(18px)',
        WebkitBackdropFilter: 'blur(18px)',
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: 360,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          gap: 2,
          p: 3,
          borderRadius: '24px',
          border: `1px solid ${alpha('#ffffff', 0.08)}`,
          background: `linear-gradient(160deg, ${alpha('#ffffff', 0.05)} 0%, ${alpha('#000000', 0.28)} 100%)`,
          boxShadow: '0 24px 48px rgba(0,0,0,0.45), inset 0 1px 0 rgba(255,255,255,0.05)',
        }}
      >
        <Box
          sx={{
            position: 'relative',
            '&::before': {
              content: '""',
              position: 'absolute',
              inset: -4,
              borderRadius: '50%',
              background: `linear-gradient(135deg, ${LOGIN_ACCENT} 0%, ${alpha(LOGIN_ACCENT, 0.2)} 100%)`,
            },
          }}
        >
          <Avatar
            sx={{
              width: 72,
              height: 72,
              bgcolor: LOGIN_ACCENT,
              color: '#04120e',
              fontWeight: 800,
              fontSize: '1.5rem',
              position: 'relative',
              border: `3px solid ${THEME_COLORS.BACKGROUND_DARK}`,
            }}
          >
            {initial}
          </Avatar>
        </Box>

        <Box>
          <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75, mb: 0.75 }}>
            <LockOutlinedIcon sx={{ color: LOGIN_ACCENT, fontSize: 18 }} />
            <Typography sx={{ color: LOGIN_ACCENT, fontWeight: 800, fontSize: '0.78rem', letterSpacing: '0.08em' }}>
              SCREEN LOCKED
            </Typography>
          </Box>
          <Typography sx={{ color: '#f8fafc', fontWeight: 800, fontSize: '1.15rem', mb: 0.5 }}>
            {displayName}
          </Typography>
          <Typography sx={{ color: alpha('#94a3b8', 0.95), fontSize: '0.86rem', lineHeight: 1.45 }}>
            Your session is paused. Unlock to continue using RoomNexa.
          </Typography>
        </Box>

        <Button
          fullWidth
          variant="contained"
          onClick={onUnlock}
          sx={{
            mt: 0.5,
            minHeight: 48,
            borderRadius: '14px',
            bgcolor: LOGIN_ACCENT,
            color: '#04120e',
            fontWeight: 800,
            fontSize: '0.92rem',
            boxShadow: `0 10px 24px ${alpha(LOGIN_ACCENT, 0.24)}`,
            '&:hover': {
              bgcolor: LOGIN_ACCENT,
              opacity: 0.92,
            },
          }}
        >
          Unlock
        </Button>
      </Box>
    </Box>
  );
}
